import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Reacttemplate extends Component {
  render() {
    const course = [
      {
        title: "React Introduction",
        content: ["React Features and Benefits", "JavaScript Basics and Fundementals", "ReactJS Installation and Setup", "Creating a React Application", "Files and Folders Structure", "Run the application", "Variable(ES6)"]
      },
      {
        title: "React-JSX",
        content: ["JSX introduction", "JSX in JavaScript", "JSX and XML Different", "JSX Expressions", "JSX Functions and Attributes"]
      },
      {
        title: "ReactJS Component",
        content: ["Components Introduction", "Advantage of Components in React", "Types of Components", "Stateless and Stateful Component Creations", "Creating a Class Component", "Advantages of Class Components", "Creating a Function Component", "Advantages of Function Component"]
      },
      {
        title: "React Styling",
        content: ["Inline Styling", "Internal Styling", " Importing CSS Stylesheet in Component", "Using JSX Attributes for styling the Component"]
      },
      {
        title: "React State Method for Class Components",
        content: ["What is React-State?", "Creating State in Class Components", "Set the value for State", "Change the value using SetState Method", "Using State and SetState for Event Handling"]
      },
      {
        title: "React Hooks Method for Function Components",
        content: ["React Hooks Introduction", "State and UseState in Component", " Creating Click-Event using State and UseState", "Effect and UseEffect in Component", "Set-Time using Effect and UseEffect ", "Using other Hooks for Event managment"]
      },
      {
        title: "React Properties(props) in Components",
        content: ["Uses of React Props", "Creating a Class Component using Props", "Rendering the Props in other page", "Using Props in Function Component", "Creating the Map Methods Using Props "]
      },
      {
        title: "React Router",
        content: ["Define React Router", "Install React Router", "Types in Router", "Define the types", "Creating Navigation using NavLink and Link"]
      },
      {
        title: "React Form",
        content: ["Form Introduction", "Create a Form", "Controlled Component", "Uncontrolled Component", "Set default value", "Change the input value using State method", "Form submit", "Form validation"]
      },
      {
        title: "React Redux",
        content: ["Redux Introduction", "Redux Installation", "Redux Setting", "Redux Concepts", "Redux API", "Saga method in Redux"]
      },
      {
        title: "Building and Deployment",
        content: ["Install the npm package", "Run the application", "Build the code in folder", "Deploying Build using the server"]
      }
    ]

    const faqData = [
      {
        question: 'What are the prerequisites for enrolling in this ReactJS course?',
        answer:
          'To enroll in our ReactJS course, you should have a solid understanding of JavaScript fundamentals, including variables, functions, objects, and arrays. Familiarity with HTML and CSS is also recommended',
      },
      {
        question: 'What level of support and mentorship is available throughout the ReactJS course?',
        answer:
          'We have a dedicated team of experienced ReactJS instructors and mentors who will provide you with personalized support, code reviews, and guidance throughout the course',
      },
      {
        question: 'Do you offer any discounts or payment plans for the ReactJS course? ',
        answer:
          'We offer various discounts and payment plans to make our ReactJS course more accessible. Early bird discounts, group enrollment discounts, and flexible monthly payment options are available'
        
        },
      {
        question: 'Will I receive a certificate upon completing the React Training?',
        answer:
          'Yes, you will receive a certificate of completion after successfully finishing the ReactJS course and meeting all the requirements'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To enroll in our comprehensive ReactJS course and embark on your journey to master React Training, we recommend having a solid understanding of JavaScript fundamentals, including concepts like variables, functions, objects, and arrays. Familiarity with HTML and CSS is also beneficial, as ReactJS seamlessly integrates with these web technologies. While prior experience with front-end development frameworks is not mandatory, it can certainly provide you with a smoother learning curve. Our ReactJS course is designed for developers of all skill levels, from beginners seeking to enhance their front-end prowess to experienced professionals aiming to stay up-to-date with the latest ReactJS best practices"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Anjali",
          date:" july 09 ,2023",
          review:`The decision to enroll in ReactJS training at Learnsoft Institute is a wise one. By completing this training, you not only gain a deep understanding of ReactJS but also acquire practical skills that can be directly applied in your professional life. Whether you're just starting in the field of cybersecurity or looking to advance your existing skills, ReactJS training at Learnsoft is the key to unlocking your full potential.`
        
        },
      {
         img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Vedha",
          date:" july 29 ,2023",
          review:`ReactJS is changing the game in web development, and the best way to be part of this revolution is through ReactJS training in  ${this.props.location}. At Learnsoft.org, we provide a structured path to help you become a ReactJS expert.`
        },
  ]
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of web development, ReactJS emerges as a game-changer. It is a versatile, free, and open-source front-end JavaScript library, purpose-built for crafting seamless user interfaces through a component-based approach. Maintained by Meta (formerly Facebook) in conjunction with a dedicated community of developers and companies, ReactJS has revolutionized the way web applications are constructed."/> */}
          <NewMainsec rating='4.9' students={"832"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of web development, ReactJS emerges as a game-changer. It is a versatile, free, and open-source front-end JavaScript library, purpose-built for crafting seamless user interfaces through a component-based approach. Maintained by Meta (formerly Facebook) in conjunction with a dedicated community of developers and companies, ReactJS has revolutionized the way web applications are constructed."/>

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
	       	<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`ReactJS ${this.props.location1} is a popular field with a growing demand for professionals with ReactJS skills. At Learnsoft.org, we offer top-notch ReactJS training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of ReactJS principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to ReactJS or looking to expand your skillset, Learnsoft.org's ReactJS ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our ReactJS courses and start your ReactJS journey.`} 
          title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our ReactJS course covers a wide range of topics, including ReactJS components, ReactJS state management, and ReactJS hooks. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in ReactJS. By the end of the course, you will be able to implement ReactJS practices in your own projects."}/>
         </section>
 <Batchtime title={this.props.title} fees="20,999" offer="15,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
         <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Java" coupath7="java" cou6='Python' coupath6='python' cou4='Full Stack Developer' coupath4='full-stack-developer' cou='AngularJS' coupath='angularjs' cou3='Front End Developer' coupath3='front-end-developer'
          cou10='R Programming' coupath10='rprogram' cou9='JavaScript' coupath9='javascript' cou1='VueJS' coupath1='vuejs'
          cou5='TypeScript' coupath5='type-script' cou2='Flutter' coupath2='flutter'  cou8='Go' coupath8='go' />

      </>
    );
  }
}
